import { Badge, MenuItem, Stack, Typography } from '@mui/material'
import {
  Notification,
  NotificationStatus
} from '@shared/types/notifications.types'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useUpdateNotificationMutation } from '../hooks/useMutations/useNotificationsMutations'
import { getElapsedTime } from '../utils/date.utils'
import NotificationContent from './NotificationContent'

export default function NotificationMenuItem({
  notification,
  handleCloseMenu
}: {
  notification: Notification
  handleCloseMenu: () => void
}) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { translationKey, translationParams } = getElapsedTime(
    notification.createdAt
  )
  const updateNotificationMutation = useUpdateNotificationMutation(
    notification.userId
  )

  const handleNotificationLinkClick = () => {
    handleCloseMenu?.()
    if (notification.link) {
      navigate(notification.link)
    }
  }

  const isRead = notification.status === NotificationStatus.READ

  return (
    <MenuItem
      divider
      disableGutters
      sx={{
        padding: 0,
        ...(isRead ? { bgcolor: '#272B2E' } : { bgcolor: '#3A3D40' })
      }}
      onClick={() => {
        updateNotificationMutation.mutate({
          notificationId: notification.id,
          data: {
            status: isRead ? NotificationStatus.UNREAD : NotificationStatus.READ
          }
        })
      }}
    >
      <Stack
        direction='row'
        justifyContent='space-between'
        width='100%'
        padding='1rem'
      >
        <Stack direction='row' spacing='1rem'>
          <NotificationContent
            notification={notification}
            t={t}
            onLinkClick={handleNotificationLinkClick}
          />
        </Stack>
        <Stack direction='row' spacing='0.75rem' alignItems='center'>
          {notification.status === NotificationStatus.UNREAD && (
            <Badge variant='dot' color='primary' />
          )}
          <Typography variant='caption' color='text.secondary'>
            {t(translationKey, translationParams).toString()}
          </Typography>
        </Stack>
      </Stack>
    </MenuItem>
  )
}
